// Compact quota display: used / limit with a progress bar.
function UsageBar({ stats }) {
    if (!stats) return null;
    const { used = 0, limit = 0, remaining = 0 } = stats;
    const pct = limit > 0 ? Math.min(100, Math.round((used / limit) * 100)) : 0;
    const low = limit > 0 && remaining <= Math.max(1, limit * 0.1);

    return (
        <div className="usage">
            <div className="usage__row">
                <span className="usage__label">Reports used</span>
                <span className="usage__count">
                    {used.toLocaleString()} <span className="usage__slash">/</span> {limit.toLocaleString()}
                </span>
            </div>
            <div className="usage__track">
                <div className={`usage__fill${low ? " usage__fill--low" : ""}`} style={{ width: `${pct}%` }} />
            </div>
            <div className="usage__remaining">{remaining.toLocaleString()} remaining</div>
        </div>
    );
}

export default UsageBar;
